<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
const $root = getCurrentInstance()?.appContext.config.globalProperties

import { useI18n } from 'vue-i18n'
const { t } = useI18n()

import PopupResetLine from './PopupResetLine.vue';
const refPopupResetLine = ref(null)

import { SettingsStore } from "store/settings";
const settingsStore = SettingsStore();

onMounted(async () => {
  settingsStore.type = 'line'
  //get list template
  await settingsStore.getSetting()
})

const clearSetting = async () => {
  $root.$overlay.show()
  const response = await settingsStore.deleteSetting()
  if (response.code == 200) {
    refPopupResetLine.value.show(false)

    //reload sample value
    settingsStore.getSetting()
  }
  else {
    $root.notify({ group: 'top', message: t('msg_save_error'), type: 'error' })
  }
  $root.$overlay.hide()
}

const save = async () => {
  checkForm()
  if (Object.keys(settingsStore.error).length > 0) {
    $root.notify({ group: 'top', message: t('require_field_notice'), type: 'error' })
    return
  }
  //save function here
  $root.$overlay.show()
  settingsStore.saveSetting().then(response => {

    let _msg = ''
    let type = 'warning'
    if (response.code == 200 && response.errors.length == 0) {
      _msg = t('msg_success')
      type = 'success'
      //get config
      settingsStore.getSetting()
    }
    else {
      _msg = t('msg_save_error')
    }
    $root.notify({ group: 'top', message: _msg, type: type })

    $root.$overlay.hide()
  })


}
const checkForm = () => {
  settingsStore.error = {}

  if (!settingsStore.item.access_token) {
    settingsStore.error.access_token = true
  }
  // if (!settingsStore.item.secret) {
  //   settingsStore.error.secret = true
  // }
  // if (!settingsStore.item.channel_id) {
  //   settingsStore.error.channel_id = true
  // }
}

</script>
<template>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col sm:flex-row justify-between gap-2 sm:gap-4">
      <div class="flex text-xl sm:text-2xl font-bold text-blue-910 items-center">ライン設定</div>
      <div>
        <button class="btn-delete shadow w-full sm:w-auto text-sm sm:text-base" @click="refPopupResetLine.show()"
          v-if="!settingsStore.default">Line送受信設定を解</button>
      </div>
    </div>

    <div class="flex bg-white flex-col divide-y divide-slate-200 rounded border drop-shadow text-sm border-slate-400">
      <div class="p-1 flex items-center bg-slate-150">
        Line情報と設定
      </div>

      <div class="p-2 flex flex-col sm:flex-row gap-2 items-stretch sm:items-center">
        <div class="w-full sm:w-48 flex-none">チャネルID</div>
        <div class="grow">
          <input type="text" class="rounded h-7 border px-2 w-full" v-model.trim="settingsStore.item.channel_id"
            :class="settingsStore.error.channel_id ? 'border-red-500' : 'border-default'" />
        </div>
        <div class="w-12 flex-none text-red-500 text-xs">※必須</div>
      </div>

      <div class="p-2 flex flex-col sm:flex-row gap-2 items-stretch sm:items-center">
        <div class="w-full sm:w-48 flex-none">チャネルアクセストークン</div>
        <div class="grow">
          <input type="text" class="rounded h-7 border px-2 w-full" v-model.trim="settingsStore.item.access_token"
            :class="settingsStore.error.access_token ? 'border-red-500' : 'border-default'" />
        </div>
        <div class="w-12 flex-none text-red-500 text-xs">※必須</div>
      </div>

      <div class="p-2 flex items-center justify-center">
        <button class="btn-save shadow" @click="save()">保存</button>
      </div>

    </div>

    <div class="flex flex-col gap-2 pt-4" v-if="settingsStore.item.qrcode">
      <div>QRコードのスキャンまたは共有: </div>
      <div>
        <a :href="settingsStore.item.qrcode" target="_blank" class="hover:text-blue-810 break-all">
          {{ settingsStore.item.qrcode }}
        </a>
      </div>
      <div class="max-w-[240px]">
        <img :src="settingsStore.item.qrcode">
      </div>
    </div>

    <PopupResetLine ref="refPopupResetLine" @clear-setting="clearSetting" />
  </div>
</template>
